import api from "../api";
import UIComponent from "../ui/component";
import createContentObserver from "../utils/createContentObserver";

export class CheckboxShow extends UIComponent {
    init() {
        this.includeComponents({
            TranscriberSettings: "document@#TranscriberSettings",
        });

        this.completedResult = new Set();

        this.statusAiPromt();

        const strokeText =
            this.select_speaker?.select_stroke.selectSelected.selectedText.el();
        if (strokeText && strokeText.textContent.trim() === "Выбрать") {
            strokeText.textContent = "2";
        }

        const symbolText =
            this.select_speaker?.select_symbol.selectSelected.selectedText.el();
        if (symbolText && symbolText.textContent.trim() === "Выбрать") {
            symbolText.textContent = "35";
        }

        this.states = {
            speakers: this.speaker_check?.isChecked() || false,
            timestamps: this.timestamps_check?.isChecked() || false,
            subtitles: this.subtitles_check?.isChecked() || false,
            maxLines:
                parseInt(
                    this.select_speaker?.select_stroke.selectSelected.selectedText.el()
                        .textContent
                ) || 2,
            maxSymbols:
                parseInt(
                    this.select_speaker?.select_symbol.selectSelected.selectedText.el()
                        .textContent
                ) || 35,
        };

        if (this.speaker_open && this.subtitles_open) {
            this.speaker_open.on("click", (event) => {
                event.preventDefault();
                this.TranscriberSettings.open({}, true);
            });
            this.subtitles_open.on("click", (event) => {
                event.preventDefault();
                this.TranscriberSettings.open({}, true);
            });
        }

        this.setupEventListeners();
        this.updateExportLinks();
        this.toggleSpeakerSelectVisibility();

        this.fileNameWrapper.fileName.on("click", (e) => {
            e.stopPropagation();
            const nameWrapper = this.fileNameWrapper;
            // if (!nameWrapper.hasClass("file-edit-active")) {
            //     nameWrapper.addClass("file-edit-active");
            //     const removeActive = (event) => {
            //         if (!nameWrapper.hasClass(event.target)) {
            //             nameWrapper.removeClass("file-edit-active");
            //             document.removeEventListener("click", removeActive);
            //         }
            //     };
            //     document.addEventListener("click", removeActive);
            //     return;
            // }
            // nameWrapper.removeClass("file-edit-active");
            this.editFileName();
        });
    }

    async statusAiPromt() {
        const url = this.status_url;

        try {
            const data = await api.get(url);

            const completed = data.variants.every(
                (item) => item.status === this.status_completed
            );

            data.variants.forEach(async (item) => {
                // Найти компонент прогресс-бара для этого варианта
                const Tbx = this.tbx || window.Tbx;
                const progressEl = document.querySelector(`[data-tbx-component="ProgressVariant"][data-variant-id="${item.id}"]`);
                const progressComponent = progressEl ? Tbx?.getComponentByElement?.(progressEl) : null;
                
                if (item.status === this.status_pending || item.status === this.status_processing) {
                    // Передаем данные в компонент прогресс-бара
                    if (progressComponent && item.estimate && item.passed !== undefined) {
                        progressComponent.updateProgress(item.estimate, item.passed);
                    } else if (!progressComponent) {
                        console.warn(`Progress component not found for variant ${item.id}`);
                    } else if (!item.estimate || item.passed === undefined) {
                        console.warn(`Missing estimate or passed for variant ${item.id}`, {
                            estimate: item.estimate,
                            passed: item.passed
                        });
                    }
                    
                    if (!this.statusInterval) {
                        this.statusInterval = setInterval(() => {
                            this.statusAiPromt();
                        }, 3000);
                    }
                } else if (item.status === this.status_completed) {
                    // Завершаем прогресс
                    if (progressComponent) {
                        progressComponent.complete();
                    }
                    
                    if (!this.completedResult.has(item.id)) {
                        this.completedResult.add(item.id);
                        (async () => {
                            try {
                                const data = await api.get(item.links.result);
                                this.resultTabs.updateAiTabContent(
                                    item.id,
                                    data.content
                                );
                            } catch (e) {
                                console.error(e);
                            }
                        })();
                    }
                } else if (item.status === this.status_failed) {
                    // Показываем ошибку
                    if (progressComponent) {
                        progressComponent.showError();
                    }
                }
            });

            if (completed && this.statusInterval) {
                clearInterval(this.statusInterval);
                this.statusInterval = null;
            }
        } catch (e) {
            console.error(e);
        }
    }

    openSetting() {}

    setupEventListeners() {
        if (this.speaker_check) {
            this.speaker_check.on("change", () => {
                this.states.speakers = this.speaker_check.isChecked();
                this.sendUpdateRequest();
            });
        }

        if (this.timestamps_check) {
            this.timestamps_check.on("change", () => {
                this.states.timestamps = this.timestamps_check.isChecked();
                this.sendUpdateRequest();
            });
        }

        if (this.subtitles_check) {
            this.subtitles_check.on("change", () => {
                this.states.subtitles = this.subtitles_check.isChecked();
                this.toggleSpeakerSelectVisibility();
                this.sendUpdateRequest();
            });
        }

        if (this.select_speaker?.select_stroke) {
            const container = this.select_speaker.select_stroke.element;
            const selectedText =
                this.select_speaker.select_stroke.selectSelected.selectedText.el();
            const options = container.querySelectorAll(
                ".language-choice__custom-select__select-option"
            );

            options.forEach((opt) => {
                opt.addEventListener("click", () => {
                    const value = parseInt(opt.dataset.value);
                    selectedText.textContent = value;
                    this.states.maxLines = value;
                    this.sendUpdateRequest();
                });
            });

            this.select_speaker.select_stroke.on("option-selected", (e) => {
                const value = e.detail.value;
                selectedText.textContent = value;
                this.states.maxLines = value;
                this.sendUpdateRequest();
            });
        }

        if (this.select_speaker?.select_symbol) {
            const container = this.select_speaker.select_symbol.element;
            const selectedText =
                this.select_speaker.select_symbol.selectSelected.selectedText.el();
            const options = container.querySelectorAll(
                ".language-choice__custom-select__select-option"
            );

            options.forEach((opt) => {
                opt.addEventListener("click", () => {
                    const value = parseInt(opt.dataset.value);
                    selectedText.textContent = value;
                    this.states.maxSymbols = value;
                    this.sendUpdateRequest();
                });
            });

            this.select_speaker.select_symbol.on("option-selected", (e) => {
                const value = e.detail.value;
                selectedText.textContent = value;
                this.states.maxSymbols = value;
                this.sendUpdateRequest();
            });
        }
    }

    async sendUpdateRequest() {
        const observer = createContentObserver(() => {
            this.textPreloader?.hide();
            this.enableOptions();
            observer.disconnect();
        });

        try {
            observer.observe(this.text_transcriber.element);
            this.textPreloader?.show();
            this.disableOptions();

            const response = await api.post(
                `/files/${this.timestamps_check.transcription}/text`,
                {
                    speakers: this.states.speakers,
                    timestamps: this.states.timestamps,
                    maxLineCount: this.states.subtitles
                        ? this.states.maxLines
                        : null,
                    maxLineWidth: this.states.subtitles
                        ? this.states.maxSymbols
                        : null,
                }
            );

            if (this.text_transcriber?.element) {
                this.text_transcriber.element.innerHTML =
                    typeof response !== "object" ? response : response.data;
            }

            this.updateExportLinks();
            this.textPlayer?.updateWords();
        } catch (error) {
            console.error("Failed to update text display:", error);
            this.textPreloader?.hide();
            this.enableOptions();
            observer?.disconnect();
        }
    }

    toggleSpeakerSelectVisibility() {
        if (this.states.subtitles) {
            this.select_speaker?.show();
        } else {
            this.select_speaker?.hide();
        }
    }

    updateExportLinks() {
        const exportLinks = document.querySelectorAll(".actions-export");

        exportLinks.forEach((link) => {
            try {
                const url = new URL(link.href);
                url.searchParams.set(
                    "speakers",
                    this.states.speakers ? "1" : "0"
                );
                url.searchParams.set(
                    "timestamps",
                    this.states.timestamps ? "1" : "0"
                );
                if (this.states.subtitles) {
                    url.searchParams.set(
                        "maxLineCount",
                        this.states.maxLines.toString()
                    );
                    url.searchParams.set(
                        "maxLineWidth",
                        this.states.maxSymbols.toString()
                    );
                } else {
                    url.searchParams.delete("maxLineCount");
                    url.searchParams.delete("maxLineWidth");
                }

                link.href = url.toString();
            } catch (error) {
                console.error("Failed to update export link:", error);
            }
        });
    }

    editFileName() {
        const oldSpan = this.fileNameWrapper.fileName.el();
        const currentName = oldSpan.textContent.replace(/\s+/g, " ").trim();
        const originalTitle = oldSpan.getAttribute("title");
        const input = document.createElement("div");

        input.className = "file-edit-input";
        input.contentEditable = true;
        input.textContent = currentName;

        oldSpan.replaceWith(input);

        input.focus();
        input.click();
        const range = document.createRange();
        range.selectNodeContents(input);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        const save = (newName) => {
            oldSpan.textContent = newName;
            oldSpan.setAttribute("title", newName);
            input.replaceWith(oldSpan);
            if (newName !== currentName) this.saveEdit(newName);
        };

        input.addEventListener("blur", () => {
            const newName =
                input.textContent.replace(/\s+/g, " ").trim() || currentName;
            save(newName);
        });

        input.addEventListener("keydown", (ev) => {
            if (ev.key === "Enter" && !ev.shiftKey) {
                ev.preventDefault();
                const newName =
                    input.textContent.replace(/\s+/g, " ").trim() ||
                    currentName;
                save(newName);
            }
            if (ev.key === "Escape") {
                ev.preventDefault();
                oldSpan.textContent = currentName;
                oldSpan.setAttribute("title", originalTitle);
                input.replaceWith(oldSpan);
            }
        });
    }

    async saveEdit(newName) {
        if (this.saveLoading) {
            this.saveLoading.removeClass("d-none");
        }
        if (this.saveSucces) {
            this.saveSucces.addClass("d-none");
        }

        try {
            const url = this.fileNameWrapper.fileName.url;

            const data = await api.post(url, {
                title: newName,
            });

            if (this.saveLoading) {
                this.saveLoading.addClass("d-none");
            }
            if (this.saveSucces) {
                this.saveSucces.removeClass("d-none");
            }
        } catch (error) {
            if (this.saveLoading) {
                this.saveLoading.addClass("d-none");
            }
        }
    }

    disableOptions() {
        this.speaker_check?.disable();
        this.timestamps_check?.disable();
        this.subtitles_check?.disable();
        this.select_speaker?.select_stroke.disable();
        this.select_speaker?.select_symbol.disable();
    }

    enableOptions() {
        this.speaker_check?.enable();
        this.timestamps_check?.enable();
        this.subtitles_check?.enable();
        this.select_speaker?.select_stroke.enable();
        this.select_speaker?.select_symbol.enable();
    }
}
